export const pageOptions = [
    { value: 10, name: "Show 10 Per Page" },
    { value: 20, name: "Show 20 Per Page" },
    { value: 50, name: "Show 50 Per Page" },
    { value: 100, name: "Show 100 Per Page" },
    { value: 150, name: "Show 150 Per Page" },
];

export const certificationLevels = [
    {
        value: "bachelors-degree-psychology",
        label: "Bachelor’s Degree in Psychology",
    },
    {
        value: "masters-degree-clinical-psychology",
        label: "Master’s Degree in Clinical Psychology",
    },
    { value: "phd-psychiatry", label: "PhD in Psychiatry" },
    {
        value: "licensed-mental-health-counselor",
        label: "Licensed Mental Health Counselor (LMHC)",
    },
    {
        value: "licensed-professional-counselor",
        label: "Licensed Professional Counselor (LPC)",
    },
    {
        value: "registered-psychiatric-nurse",
        label: "Registered Psychiatric Nurse",
    },
    { value: "licensed-social-worker", label: "Licensed Social Worker (LCSW)" },
    {
        value: "certification-cbt",
        label: "Certification in CBT (Cognitive Behavioral Therapy)",
    },
    {
        value: "certification-dbt",
        label: "Certification in DBT (Dialectical Behavioral Therapy)",
    },
    { value: "certified-life-coach", label: "Certified Life Coach" },
    { value: "other", label: "Other – User input" },
];

export const experienceOptions = [
    { value: "1-3 years", label: "1-3 years" },
    { value: "3-5 years", label: "3-5 years" },
    { value: "5-10 years", label: "5-10 years" },
    { value: "10-15 years", label: "10-15 years" },
    { value: "15+ years", label: "15+ years" },
];